import { Link, Outlet, useLocation, useParams } from 'react-router-dom';
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  HStack,
  Image,
} from '@chakra-ui/react';

import { ReactComponent as ChevronRightIcon } from '../../assets/icons/chevron-right.svg';
import { useGetTeamMemberByIdQuery } from '../../services';

export const PartnersLayout = () => {
  const location = useLocation();
  const params = useParams();
  const { companyId } = params;
  const status = params.status || 'all';

  const { data } = useGetTeamMemberByIdQuery(Number(companyId), {
    skip: !companyId,
  });

  return (
    <Box mx="8" h="full" display="flex" flexDirection="column">
      <Breadcrumb separator={<ChevronRightIcon />}>
        <BreadcrumbItem>
          <HStack fontSize="xs" color="custom_blue.1">
            <Image src="/sidebar/users.svg" alt="roles icon" boxSize="4" />
            <Box>Companies</Box>
          </HStack>
        </BreadcrumbItem>

        <BreadcrumbItem isCurrentPage={location.pathname.endsWith(status)}>
          <BreadcrumbLink
            as={Link}
            to={`/partners`}
            fontSize="xs"
            color="custom_blue.1"
            textTransform="capitalize"
          >
            All Companies
          </BreadcrumbLink>
        </BreadcrumbItem>

        {(location.pathname.includes('new-company') || companyId) && (
          <BreadcrumbItem
            isCurrentPage={location.pathname.endsWith('new-company')}
          >
            {companyId ? (
              <BreadcrumbLink
                as={Link}
                to={`/companies/${companyId}`}
                fontSize="xs"
                color="custom_blue.1"
              >
                {data?.data.firstName}
              </BreadcrumbLink>
            ) : (
              <BreadcrumbLink
                as={Link}
                to={`/companies/new-company`}
                fontSize="xs"
                color="custom_blue.1"
              >
                Add New Company
              </BreadcrumbLink>
            )}
          </BreadcrumbItem>
        )}
      </Breadcrumb>

      <Outlet />
    </Box>
  );
};
